// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dBpN","left":"styles_left__1U3mo"};